import { useRecordContext } from 'react-admin';

const ClickableImageField = ({ source, label }) => {
  const record = useRecordContext();
  if (!record || !record[source]) return null;

  const url = record[source];

  const handleClick = (e) => {
    e.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer'); // открыть в новом окне/вкладке
  };

  return (
    <a href={url} onClick={handleClick} title="Открыть">
      <img
        src={url}
        alt={label || 'image'}
        style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: '50%' }}
      />
    </a>
  );
};

export default ClickableImageField;
